var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8998 0C58.3998 0 196.2 0 198.7 0C205.6 0 212.3 1.1 218.8 3.4C228.2 6.8 236.7 12.8 243.1 20.6C249.6 28.4 253.9 38 255.4 48C256 51.7 256.1 55.4 256.1 59.1C256.1 62.5 256.1 182.3 256.1 187.7C256.1 190.9 256.1 194.2 256.1 197.4C256.1 201.8 255.9 206.3 255 210.6C253 220.5 248.3 229.8 241.5 237.3C234.8 244.8 226 250.4 216.5 253.4C210.7 255.2 204.7 256 198.6 256C195.9 256 56.4998 256 54.3998 255.9C44.1998 255.4 34.0998 252.1 25.5998 246.4C17.2998 240.8 10.4998 233 6.09978 224C2.29978 216.3 0.399778 207.7 0.399778 199.1C0.399778 197.1 0.399778 58.9 0.399778 56.9C0.199778 48.4 1.99978 40 5.69978 32.4C9.99978 23.4 16.6998 15.5 24.9998 9.9C33.4998 4.1 43.4998 0.7 53.6998 0.2C54.6998 0 55.7998 0 56.8998 0Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 209.4C215.1 208 214.1 206.6 213 205.3C210.5 202.3 207.6 199.7 204.4 197.5C200.4 194.8 195.7 193.1 190.9 192.9C187.5 192.7 184.1 193.3 180.9 194.5C177.7 195.6 174.6 197.2 171.6 198.8C168.1 200.6 164.6 202.4 160.9 203.9C156.5 205.7 151.9 207.1 147.2 208.1C141.3 209.2 135.3 209.6 129.4 209.5C118.7 209.3 108 207.7 97.8 204.7C88.8 202 80.2 198.3 72.1 193.6C65 189.5 58.4 184.8 52.2 179.5C47.1 175.1 42.4 170.4 38 165.4C35 161.9 32.1 158.2 29.4 154.4C28.3 152.9 27.3 151.3 26.4 149.7L0 121.2V56.7C0 25.4 25.3 0 56.6 0H107.1L144.5 38C228.9 95.4 201.6 158.7 201.6 158.7C201.6 158.7 225.6 185.7 216 209.4Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7 38C229.1 95.4 201.8 158.7 201.8 158.7C201.8 158.7 225.8 185.8 216.1 209.5C216.1 209.5 206.2 192.9 189.6 192.9C173.6 192.9 164.2 209.5 132 209.5C60.3004 209.5 26.4004 149.6 26.4004 149.6C91.0004 192.1 135.1 162 135.1 162C106 145.1 44.1004 64.3 44.1004 64.3C98.0004 110.2 121.3 122.3 121.3 122.3C107.4 110.8 68.4004 54.6 68.4004 54.6C99.6004 86.2 161.6 130.3 161.6 130.3C179.2 81.5 144.7 38 144.7 38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 152.29,
    y1: -9.1348,
    x2: 103.923,
    y2: 265.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 130.612,
    y1: 4.1363,
    x2: 95.213,
    y2: 204.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.a030128a515dc94acb447155c6988f7c.svg";
export { ForwardRef as ReactComponent };